import * as React from 'react';
import { Icon, IButtonProps, Label, Text } from 'office-ui-fabric-react';
import {
  getMenuButtonContainerStyle,
  menuButtonContentContainerStyle,
  getLabelStyle,
  iconContainerStyle,
  shortcutTextStyle
} from './MenuButton.styles';

export interface MenuButtonProps extends IButtonProps {
  /**
   * Width of the button in CSS, overriding the value specified in CSS.
   */
  overrideWidth?: number;

  index?: number;

  refCallback?: (buttonRef: HTMLButtonElement | null) => void;
}

export const MenuButton = React.memo(function MenuButton(props: MenuButtonProps) {
  const { text, secondaryText, iconProps, index, onClick, onFocus, disabled, overrideWidth, refCallback } = props;
  let styleWithOverriddenWidth = {};
  if (overrideWidth !== undefined) {
    styleWithOverriddenWidth = { width: overrideWidth };
  }

  const containerClass = getMenuButtonContainerStyle(props);

  const buttonId = 'menu-button' + index ?? '';

  return (
    <button
      role={'option'}
      className={containerClass}
      onClick={disabled ? getDisabledClickHandler : onClick}
      onFocus={onFocus}
      style={styleWithOverriddenWidth}
      data-automation-id={'discoverMenuButton'}
      id={buttonId}
      ref={(menuItem) => {
        if (refCallback && index !== undefined && index === 1 && menuItem !== null) {
          refCallback(menuItem);
        }
      }}
    >
      <span className={menuButtonContentContainerStyle} style={styleWithOverriddenWidth}>
        <span className={iconContainerStyle}>
          {/* we only support fabric icons and SVG icons right now */}
          {iconProps && iconProps.iconName && <Icon iconName={iconProps.iconName} className={iconProps.className} />}
        </span>
        <Label className={getLabelStyle(props, containerClass)}>{text}</Label>
        <Text className={shortcutTextStyle}>{secondaryText}</Text>
      </span>
    </button>
  );
});

const getDisabledClickHandler = (event: React.MouseEvent) => {
  // Prevent dismissing menu when a disabled control is clicked
  event.stopPropagation();
};
